import { useState } from 'react';
import { Sidebar, MobileMenuButton } from './Sidebar';
import { Toaster } from '../components/ui/sonner';

export const DashboardLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#F6F5F5]">
      <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />

      {/* Main content */}
      <div className="lg:ml-[260px]">
        {/* Mobile header */}
        <header className="lg:hidden glass-header sticky top-0 z-20 px-4 py-3 border-b border-[#DFDEDE] flex items-center gap-3">
          <MobileMenuButton onClick={() => setMobileOpen(true)} />
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-md bg-[#EB7B44] flex items-center justify-center">
              <span className="text-white font-bold text-sm" style={{ fontFamily: 'Manrope' }}>S</span>
            </div>
            <span className="font-bold text-[#202020]" style={{ fontFamily: 'Manrope' }}>Sellmu</span>
          </div>
        </header>

        {/* Page content */}
        <main className="p-4 md:p-6 lg:p-8">
          {children}
        </main>
      </div>

      <Toaster position="top-right" richColors />
    </div>
  );
};
